import { useState } from "react";
import type { FaqItem } from "@/mocks/faq";

export default function Accordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? -1 : index)}
                className="w-full flex items-start gap-4 py-5 md:py-6 text-left cursor-pointer group"
                aria-expanded={open}
              >
                <span
                  className={`mt-0.5 w-6 h-6 shrink-0 rounded-md flex items-center justify-center transition-colors ${
                    open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                </span>
                <span
                  className={`flex-1 font-heading text-base md:text-lg font-bold transition-colors ${
                    open ? "text-primary-700" : "text-foreground-950 group-hover:text-primary-600"
                  }`}
                >
                  {item.q}
                </span>
              </button>
            </h3>
            <div className={`accordion-panel ${open ? "open" : ""}`}>
              <div>
                <p className="pl-10 pr-2 pb-5 md:pb-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}